import { createSelector } from 'reselect';
import { selectSearchTerm, selectItemUpdates } from '../../selectors';
import _ from 'lodash';
import search from '../../reducers/search';

const selectInstallation = (state) => state.installations;

const selectInstallationGroups = (state) => selectInstallation(state).installationGroups;

const selectPendingInstallationGroups = (state) => state.newInstallationGroup.newInstallationGroups;

const selectAllInstallationGroups = (state) => _.union(selectInstallationGroups(state), selectPendingInstallationGroups(state));

const selectInstallations = (state) => selectInstallation(state).installations;

const selectInstallationUpdates = (state) => state.editor.id.updatedItems.filter(t => state.editor.id.updatedItems[t].installationObject);

const selectComparableSearchTerm = (state) => _.trim(selectSearchTerm(state)).toLowerCase();

const selectActiveInstallationGroup = (state) => selectInstallation(state).activeInstallationGroup;

const selectFabricatorInclusionPreset = (state) => state.featureInclusion.fabricatorInclusionPreset;

export { selectSearchTerm };

export const getFilteredInstallationGroups = createSelector(
  [selectInstallationGroups, selectComparableSearchTerm, selectFabricatorInclusionPreset],
  (installationGroups, searchTerm, preset) => {
    if((searchTerm.length > 0 || preset) && installationGroups && installationGroups.length > 0) {
      return installationGroups.filter(fg => {
        let filter = true;
        if(searchTerm.length > 0) {
          filter = fg.featureGroup.toLowerCase().includes(searchTerm) || fg.customDisplayName.toLowerCase().includes(searchTerm);
        }
        if(preset && preset.installationGroups) {
          let allowedInstallationGroup = false;
          for(let i = 0; i < preset.installationGroups.length; i++) {
            allowedInstallationGroup |= _.isEqual(fg.name.toLowerCase(), preset.installationGroups[i].installationGroup.toLowerCase());
          }
          filter &= allowedInstallationGroup;
        }
        return filter;
      });
    }
    return installationGroups;
  }
);

export const getActiveInstallationGroup = createSelector(
  [selectActiveInstallationGroup],
  (activeInstallationGroup) => activeInstallationGroup
)

export const getActiveinstallationGroupInstallations = createSelector(
  [selectActiveInstallationGroup],
  (activeInstallationGroup) => {
    if(activeInstallationGroup && activeInstallationGroup.installations) {
      return activeInstallationGroup.installations;
    }
    return [];
  }
)

export const getActiveInstallationGroupEnabledInstallations = createSelector(
  [getActiveinstallationGroupInstallations],
  (installations) => {
    if(installations && installations.length > 0)
      return installations.filter(i => i.forVisualizers.split(',').filter(n => n).length > 0 || i.forQuotingTool);
    return [];
  }
)

export const getActiveInstallationGroupDisabledInstallations = createSelector(
  [getActiveinstallationGroupInstallations],
  (installations) => {
    if(installations && installations.length > 0)
      return installations.filter(i => i.forQuotingTool == false && i.forVisualizers.split(',').filter(n => n).length == 0);
    return [];
  }
)

export const getActiveInstallationGroupImageStyle = createSelector(
  selectActiveInstallationGroup,
  (activeInstallationGroup) => {
    if(activeInstallationGroup) {
      const groupName = activeInstallationGroup.featureGroup.toLowerCase();
      const round = /edge[s]*\s*profile/i.test(groupName) || /faucet[s]*/i.test(groupName);
      return round ? 'round' : 'rectangular';
    }
    return 'rectangular';
  }
);

export const getActiveInstallationGroupEnabledFilteredInstallations = createSelector(
  [getActiveInstallationGroupEnabledInstallations, selectComparableSearchTerm],
  (installations, searchTerm) => {
    if(searchTerm.length > 0) {
      return installations.filter(f => f.name.toLowerCase().includes(searchTerm));
    }
    return installations;
  }
);

export const getActiveInstallationGroupDisabledFilteredInstallations = createSelector(
  [getActiveInstallationGroupDisabledInstallations, selectComparableSearchTerm],
  (installations, searchTerm) => {
    if(searchTerm.length > 0) {
      return installations.filter(f => f.name.toLowerCase().includes(searchTerm));
    }
    return installations;
  }
);

export const getActiveInstallationsForDDL = createSelector(
  [selectInstallations],
  (installations) => {
    let list = [];
      if(installations) {
      let enabledInstallations = installations.filter(f => (f.enabled && f.fabricatorData && f.fabricatorData.enabled));
      for(let installationIndex in enabledInstallations) {
        let installation = enabledInstallations[installationIndex];
        let name = installation.fabricatorData.displayName;
        if(!_.trim(name))
          name = installation.name;
        list.push({
          text: name,
          value: installation.fabricatorData.id
        });
      }
    }
    return list;
  }
)